import type { FaireProductEntity } from "../../entity_types/product";

export const p_csbb4tw3uh: FaireProductEntity = {
  token: "p_csbb4tw3uh",
  type: "product",
  name: "Milestone Mini Blush Blanket",
  brandToken: "b_189y0nghd9",
  brandName: "ChappyWrap",
  imageUrl:
    "https://cdn.faire.com/fastly/280e1b6d7464ef8a2342640b02a5364b629a32653fe36e90496e1b8cc71ec642.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e18c3e4def0cf5c95762534d13a8b1865bd967f041ad6d40d3c98733cedbef9.jpeg",
    "https://cdn.faire.com/fastly/5574c93f4935a0d225b97cae72a074df07534ef5cb20cab7f094197b092446c9.jpeg",
    "https://cdn.faire.com/fastly/b977adfd8bfe3563b82635b9b451396536c8ba05d04180f14905d04fcb27c496.jpeg",
    "https://cdn.faire.com/fastly/5d4c9bdd04250aa684f8debf926a2f1a21295a1f404b4e69bac2ab52035beb23.jpeg",
    "https://cdn.faire.com/fastly/93c76c9279d56f16f9d17d83acedf6fd15ea60ce1555ee1429a8b33433fedc7c.jpeg",
    "https://cdn.faire.com/fastly/697b8d9298cb4213c203fdfbb609335bd35ebce1dd8bf43886d547714a3494b3.jpeg",
    "https://cdn.faire.com/fastly/2f392df37d7ea999c1a8b98b6444c531348c0a45ae205e14a71efce732a27479.jpeg",
  ],
  priceDollars: 32.5,
  description:
    "Baby’s getting big—capture those monthly milestones of their first year with this backdrop they can cuddle with long after the photos are snapped.\n\n\n\nSized just right for littles and pets, our Mini Blankets are the perfect dose of comfort. This Mini Blanket is tailor-made for strollers, car seats, pet beds & more. Our unique cotton blend is hand finished with velvet binding, snuggly soft, washable & made to last. A Chappy baby blanket is a forever favorite.\n\n\n\nPlease note: The wooden milestone discs shown in photos are not included with purchase and are not available through ChappyWrap. To mark your little one’s monthly moments, we recommend using a favorite stuffed animal or special keepsake that’s meaningful to your family.\n",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:36.028Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
